import { render, staticRenderFns } from "./DefaultYields.vue?vue&type=template&id=369a9e66&scoped=true&"
import script from "./DefaultYields.vue?vue&type=script&lang=js&"
export * from "./DefaultYields.vue?vue&type=script&lang=js&"
import style0 from "./DefaultYields.vue?vue&type=style&index=0&id=369a9e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a9e66",
  null
  
)

export default component.exports